<mat-card class="decoration-card">
  <mat-card-content>

    <mat-toolbar *ngIf="!isReadonly">
      <span class="example-spacer"></span>

      <button mat-icon-button class="crud_action" matTooltip="add a test" (click)="createVessel()" *ngIf="!isReadonly">
        <mat-icon>plus_one</mat-icon>
      </button>
    </mat-toolbar>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>

      <!-- description Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Description </th>
        <td mat-cell *matCellDef="let element"> {{element.description}} </td>
      </ng-container>

      <!-- cons_year Column -->
      <ng-container matColumnDef="cons_year">
        <th mat-header-cell *matHeaderCellDef> Construction </th>
        <td mat-cell *matCellDef="let element"> {{element.cons_year}} </td>
      </ng-container>

      <!-- last_trail Column -->
      <ng-container matColumnDef="last_trail">
        <th mat-header-cell *matHeaderCellDef> Last Trail </th>
        <td mat-cell *matCellDef="let element"> {{element.last_trail}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row (click)="selectVessel(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

  </mat-card-content>
</mat-card>